import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_Cannibalization_Type_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_MODEL_CANNIBALIZATIONM_ID:  {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Model Cannibalization Type Id',       columnResourceName: 'colId', alignment: HorizAlignment.Left},  domainOptions: {}},
    CANNIBALIZATION_TYPE_NAME:     {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Model Cannibalization Type Name',        columnResourceName: 'colName', alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    CANNIBALIZATION_TYPE_ID:       {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Model Cannibalization Type Id',          columnResourceName: 'colCTId', alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    RENDER_OPTIONS:                {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Render Options',          columnResourceName: 'colRenderOpts',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 1333}},
    CUSTOMER_CANN_METHOD:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Customer Cannibalization Method',             columnResourceName: 'colCustomerCann',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PRODUCT_CANN_METHOD:           {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Product Cannibalization Method',             columnResourceName: 'colProductCann',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TIME_CANN_METHOD:              {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Time Cannibalization Method',       columnResourceName: 'colTimeCann',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    DELETED_IND:                   {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Deleted Ind', columnResourceName: 'colDeletedInd', alignment: HorizAlignment.Left}, domainOptions: {}},
    DELETED_DT:                    {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Deleted Dt', columnResourceName: 'colDeletedDt', alignment: HorizAlignment.Left}, domainOptions: {}}
};

const ModelCannibalizationTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_MODEL_CANNIBALIZATIONM_ID',
        id_ui: 'CANNIBALIZATION_TYPE_ID',
        name: 'CANNIBALIZATION_TYPE_NAME'

    },

    searchProviderFields: vUI_Model_Cannibalization_Type_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Cannibalization_Type_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const ModelCannibalizationTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "ModelCannibalizationTypeSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'CANNIBALIZATION_TYPE_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'CANNIBALIZATION_TYPE_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
       'CANNIBALIZATION_TYPE_NAME', 'CANNIBALIZATION_TYPE_ID', 'CUSTOMER_CANN_METHOD', 'PRODUCT_CANN_METHOD', 'TIME_CANN_METHOD',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelCannibalizationTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelCannibalizationTypeSearch: ISearch = {
    searchName: "Find Model Cannibalization Type",
    renderOptions: {ui5ResourceId: "ModelCannibalizationTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelCannibalizationTypeSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("ModelCannibalizationTypeBO", "ModelCannibalizationType", ModelCannibalizationTypeSearch, "Cannibalization Type Search")

export {ModelCannibalizationTypeSearch}
